import React from 'react';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import DataExplorerPage from 'components/core/data_explorer/DataExplorerPage';
import OutputQCForm from 'components/core/forms/OutputQCForm';
import ProcessUtils from 'utils/ProcessUtils';
import AdvancedTransformationQuestion from 'components/core/forms/AdvancedTransformationQuestion';


export default class OutputQCPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Assessing the Quality of Bin Averaged Data Points',
        description: 'Control when the process will flag output data points as bad or indeterminate based on properties of the input values used to compute that point.'
    };

    renderFormWithProcess() {
        const dimensionName = this.props.pageAttributes.dimensionName;

        return (
            <DataExplorerPage
                process={this.props.process}
                siteFacilities={this.props.siteFacilities}
                exploredDatastreams={this.props.exploredDatastreams}
            >
                <AdvancedTransformationQuestion
                    process={this.props.process}
                    hasWritePermissions={this.props.hasWritePermissions}
                    dimensionName={dimensionName}
                    type="outputQC"
                />
                {ProcessUtils.shouldShowWizardOutputQC(this.props.process, ['std_ind_max', 'std_bad_max', 'goodfrac_ind_min', 'goodfrac_bad_min'], dimensionName) &&
                <OutputQCForm
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    exploredDatastreams={this.props.exploredDatastreams}
                    coordinateSystemName={ProcessUtils.getWizardCoordinateSystemName(this.props.process)}
                    dimensionName={dimensionName}
                    className={this.overflowContainer}
                    border
                />
                }
            </DataExplorerPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/OutputQCPage.js